import { ShortCode } from '@highereducation/wordpress';
import { Link, LinkVariantProps } from '@highereducation/hen-ui';

interface LinkShortcodeProps extends LinkVariantProps {
  href: string;
  variant?:
    | 'primary'
    | 'secondary'
    | 'black'
    | 'white'
    | 'tertiary'
    | 'default';
  size?: 'sm' | 'md' | 'lg';
  underline?: 'always' | 'hover' | 'none';
  target?: string;
  children?: React.ReactNode;
  [key: string]: any;
}

export const LinkShortcode: ShortCode<LinkShortcodeProps> = {
  component: ({
    href,
    variant = 'default',
    size,
    underline,
    target,
    children,
  }) => {
    return (
      <Link
        href={href}
        variant={variant}
        size={size}
        underline={underline}
        target={target}
        rel={target === '_blank' ? 'noopener noreferrer' : undefined}
      >
        {children}
      </Link>
    );
  },
};
